import React, {ReactNode} from 'react'
import {Route as RRRoute, Redirect} from 'react-router-dom'
import {inject, observer} from 'mobx-react'
import Store from 'Store'

interface Props {
  component?: ReactNode
  path?: string
  exact?: boolean
  auth?: boolean | string | string[]
  store?: Store
  render?(): ReactNode
}

const Route = inject('store')(
  observer((props: Props) => {
    const {component, path, exact, auth, render, store} = props
    /*console.log('component', component)
    console.log('path', path)
    console.log('exact', exact)
    console.log('auth', auth)
    console.log('render', render)
    console.log('store', store)*/
    if (!store) return null
    if (
      (auth === true && store.users.user === undefined) ||
      (typeof auth === 'string' && store.users.user.role !== auth) ||
      (auth instanceof Array && auth.includes(store.users.user.role))
    )
      return <Redirect to="/login" />

    return <RRRoute {...{component, path, exact, auth, render}} />
  })
)

export default Route



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Route.tsx